<template>
    <div class="single-choice-step">
        <h2 v-if="data.question" ref="heading" class="text-white text-center opacity-0">
            {{ data.callback === 'RENAME-COLOR' ? renameColor(translations[data.question]) : translations[data.question] }}
        </h2>

        <div :class="[`single-choice-step__container--${data.answers.length}`, { 'single-choice-step__container--spe': data['card-type'] === 'COL-SPE' }]" class="single-choice-step__container mt-3 md:mt-7">
            <div ref="cards" v-for="(answer, index) in data.answers" :key="`answer-${index}`" :class="[`single-choice-step__answer--${data.answers.length}`, { 'max-w-[237px]': data['card-type'] !== 'COL-SPE' }]" class="single-choice-step__answer opacity-0 max-h-[237px] self-center">
                <ChoiceCard :data="answer" :translations="translations" :align="data['card-type']" @button-clicked="exitStep" class="w-full"></ChoiceCard>
            </div>
        </div>
    </div>
</template>

<script>
    import gsap from 'gsap';
    import ChoiceCard from '@/app/components/ChoiceCard.vue';

    export default {
        name: 'MatchmakerSingleChoiceStep',

        components: { ChoiceCard },

        props: {
            data: { type: Object, default: () => {} },
            wineColor: { type: String, default: '' },
            meal: { type: String, default: '' },
            translations: { type: Object, default: () => {} },
        },

        mounted() {
            if (this.data.callback && this.data.callback === 'RENAME-COLOR') {
                this.renameColor();
            }

            this.enter();
        },

        updated() {
            this.enter();
        },

        methods: {
            renameColor(question) {
                return question.replace('%color', this.wineColor);
            },

            enter() {
                window.dataLayer.push({
                    event: 'assistant_sommelier_etape',
                    numero_etape: this.data['tracking-step-number'],
                    nom_etape: this.data['tracking-step-name'],
                    choix: null,
                });

                this.tl = gsap.timeline();

                this.tl.fromTo(
                    this.$refs.heading,
                    {
                        y: 20,
                        opacity: 0,
                    },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.5,
                        ease: 'power1.out',
                    },
                );

                this.tl.fromTo(
                    this.$refs.cards,
                    {
                        y: 20,
                        opacity: 0,
                    },
                    {
                        y: 0,
                        stagger: 0.1,
                        opacity: 1,
                        duration: 0.7,
                        ease: 'power1.out',
                    },
                    0.4,
                );
            },

            exitStep(choice) {
                window.dataLayer.push({
                    event: 'assistant_sommelier_etape',
                    numero_etape: this.data['tracking-step-number'],
                    nom_etape: this.data['tracking-step-name'],
                    choix: `${choice['tracking-value']}`,
                });

                this.tl = gsap.timeline({
                    delay: 0.5,
                    onComplete: () => {
                        this.$emit('end-step', choice);
                    },
                });

                this.tl.to(this.$refs.heading, {
                    y: -20,
                    opacity: 0,
                    duration: 0.4,
                    ease: 'power1.out',
                });

                this.tl.to(
                    this.$refs.cards,
                    {
                        y: -20,
                        stagger: 0.1,
                        opacity: 0,
                        duration: 0.5,
                        ease: 'power1.out',
                    },
                    0.2,
                );
            },
        },
    };
</script>

<style lang="scss">
    .single-choice-step {
        &__container {
            @apply grid grid-cols-2 grid-rows-3 justify-center items-center gap-3 mx-auto;

            &--4 {
                @screen md {
                    max-width: 984px;
                    @apply grid-cols-4 grid-rows-1;
                }
            }

            &--5 {
                &.single-choice-step__container--spe {
                    @apply grid-rows-5 grid-cols-1;

                    @screen md {
                        max-width: 640px;
                        @apply grid-cols-3 grid-rows-2;
                    }

                    @screen lg {
                        max-width: 1048px;
                        @apply grid-cols-5 grid-rows-1;
                    }
                }

                @screen md {
                    max-width: 1048px;
                    @apply grid-cols-5 grid-rows-1;
                }
            }

            &--6 {
                @screen md {
                    max-width: 640px;
                    @apply grid-cols-3 grid-rows-2;
                }

                @screen lg {
                    max-width: 1080px;
                    @apply grid-cols-6 grid-rows-1;
                }
            }
        }
    }
</style>
